/**
 * Auth feature barrel export.
 *
 * The single hook consumers use is `useAuthContext()` — reads the
 * shared auth state from React Context. `useAuth` itself is internal
 * (lives behind `AuthProvider`) and not exported, so we have exactly
 * one writer of auth state per page.
 */

export { LoginForm } from "./components/LoginForm";
export { RegisterForm } from "./components/RegisterForm";
export { AuthProvider, useAuthContext } from "./components/AuthProvider";
export { UserMenu } from "./components/UserMenu";
export {
  getAccessToken,
  setAccessToken,
  clearAccessToken,
  isAccessTokenValid,
  forceSignOut,
} from "./lib/session";
export type { SignOutReason } from "./lib/session";
export * from "./types";
